(function(){
  /******VIDEO REVIEWS SLIDER*******/

  const videoReviewSlider = new Swiper(".video--review--slider",{
    spaceBetween: 10,
    breakpoints: {
      320: {
        slidesPerView: 2.15
      },
      480: {
        slidesPerView: 2.25
      },
      750: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      }
    }
  })

 



  /******VIDEO PLAYING FUNCTIONALITY*****/

  const playTrigger = document.querySelectorAll("[playTrigger]");
  if(playTrigger.length > 0){
    playTrigger.forEach(function(e){
      e.addEventListener("click",function(){
        var videos = document.getElementsByTagName('video');
        for (var i = 0; i < videos.length; i++) {
          videos[i].pause();
        }
        for (var i = 0; i < playTrigger.length; i++) {
          playTrigger[i].classList.remove("hidden");
        }
        var activeTrigger = this;
        setTimeout(function () {
          activeTrigger.closest("[videoWrapper]").querySelector("video").play();
          activeTrigger.classList.add("hidden");
        },500)
        
      })
    })
  }

  const videoTriggers = document.querySelectorAll("[videoWrapper] video");
  if(videoTriggers.length > 0){
    videoTriggers.forEach(function(e){
      e.addEventListener("click",function(){
        if(!this.paused || !this.ended){
          this.pause();
          this.closest("[videoWrapper]").querySelector("[playTrigger]").classList.remove("hidden");
        }
      })
      e.addEventListener("ended",function(){
          this.closest("[videoWrapper]").querySelector("[playTrigger]").classList.remove("hidden");
          this.load();
      })
    })
  }
})();



  var quoteSwiper = new Swiper('.quote-slider', {
  effect: "slide",
  loop: true,
  allowTouchMove: false
  ,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});


var $Speed = 500;

var imageSwiper = new Swiper('.image-slider', {
  speed: $Speed,
  loop: true, 
  lazy: {
		loadPrevNext: true,
	}
});

quoteSwiper.controller.control = this.imageSwiper;
imageSwiper.controller.control = this.quoteSwiper;



  var moveToSlideButtons = document.querySelectorAll('.ingredient_switcher');
  moveToSlideButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      var slideIndex = parseInt(button.getAttribute('data-index'), 10);
      quoteSwiper.slideTo(slideIndex); 
      imageSwiper.slideTo(slideIndex); 
    });
  });

  (function ($) {
    $('.pop-btn').on('click', function(){
        $('.lightbox').fadeIn(200);
    });

    $('.lightbox').on('click', function(event){
        if("lightbox" == event.target.className){
            $('.lightbox').fadeOut(200);
        }
    });
  
    $('.close-btn').on('click', function(){
        $('.lightbox').fadeOut(200);
    });
})(jQuery);


let SwiperTop = new Swiper('.swiper--top', {
  spaceBetween: 0,
  centeredSlides: true,
  speed: 4950,
  autoplay: {
    delay: 5,
  },
  loop: true,
  slidesPerView:'auto',
  allowTouchMove: false,
  disableOnInteraction: true
});